import { Controller } from "@hotwired/stimulus"

// Full-size image popup. The modal markup lives inside the controller
// element, so each preview carries its own image and download link.
export default class extends Controller {
  static targets = ["modal", "image", "download", "trigger"]

  open(event) {
    event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.close()
    }
  }

  // Swaps in a freshly uploaded image, e.g. from video-thumbnail-upload:uploaded.
  update(event) {
    const { fullUrl, downloadUrl } = event.detail || {}
    if (!fullUrl) return

    if (this.hasImageTarget) this.imageTarget.src = fullUrl

    if (this.hasDownloadTarget) {
      this.downloadTarget.href = downloadUrl || fullUrl
      this.show(this.downloadTarget)
    }

    if (this.hasTriggerTarget) this.show(this.triggerTarget)
  }

  // These elements carry either hidden or inline-flex, never both - with both,
  // inline-flex wins and the element never hides.
  show(element) {
    element.classList.remove("hidden")
    element.classList.add("inline-flex")
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }
}
